export default "__VITE_ASSET__h2W2RBOK__"